import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    badgeNotification: {
        background: theme.palette.red.main,
        right: '-.3rem',
        lineHeight: '.9rem',
    },
}))
